import { Box, Button } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import React from 'react'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { Wallet } from '../../types/wallet'
import { Proforma } from '../../types/walletProforma'
import { useStyles } from './styles/ActionButtons'

interface ActionButtonsProps {
  proforma: Proforma
  wallet: Wallet
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ proforma, wallet }) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Button
        variant="outlined"
        className={classes.backButton}
        component={LocalizedLink}
        to={`/adopay/wallet/${wallet.walletID}/invoice-list/${proforma.proformaID}/details`}>
        {getTranslate('Back to Invoice')}
      </Button>
      <Button
        variant="contained"
        color="primary"
        className={classes.downloadButton}
        startIcon={<GetAppIcon />}>
        {getTranslate('Download')}
      </Button>
    </Box>
  )
}

export default ActionButtons
